module.exports = __webpack_public_path__ + "static/media/IMG_5047.36937121.JPG";